export const preventDefaultAndStopPropagation = (e: React.SyntheticEvent<Element>) => {
  e.preventDefault();
  e.stopPropagation();
};
